import { marketplaces, whitelabelDomain } from '../util'

export default function WhitelabelService($rootScope) {
  'ngInject'

  this.load = function () {
    const mktStorage = localStorage.getItem('marketplaces')
    if (mktStorage) {
      $rootScope.marketplaces = JSON.parse(mktStorage)
    } else {
      $rootScope.marketplaces = marketplaces
    }

    if (!$rootScope.marketplaces) {
      $rootScope.whitelabel = false
      $rootScope.whitelabelConfig = null
    }

    const info = whitelabelDomain($rootScope.marketplaces)
    if (info.isWhitelabel) {
      $rootScope.whitelabel = info.isWhitelabel
      $rootScope.whitelabelConfig = info.config
    } else {
      $rootScope.whitelabel = false
      $rootScope.whitelabelConfig = null
    }
  }

  this.get = function () {
    return $rootScope.whitelabelConfig
  }
}
